import { useTranslate } from '@festina-life/ui/hooks'

import { useBaseBranchWorkspaces } from '../../../../hooks/useBaseBranchWorkspaces'
import { useRequiredBranchOperationsContext } from '../../../../workspace/operationsContext'
import { BranchTabsWorkspaceCreationModalButton } from '../BranchTabsWorkspaceCreationModalButton'
import { BranchWorkspaceEntry } from './BranchWorkspaceEntry'

export const BranchWorkspacesPanel = () => {
  const translate = useTranslate()
  const { branchKey } = useRequiredBranchOperationsContext()
  const branchWorkspaces = useBaseBranchWorkspaces(branchKey)

  return (
    <div className="h-full flex flex-col overflow-hidden">
      <div className="flex-col flex-1 px-1 overflow-auto">
        {branchWorkspaces.length ? (
          branchWorkspaces.map((workspace) => (
            <BranchWorkspaceEntry
              key={workspace.name}
              conciseWorkspace={workspace}
              server={branchKey.server}
            />
          ))
        ) : (
          <div className="opacity-50">{translate('empty')}</div>
        )}
      </div>
      <BranchTabsWorkspaceCreationModalButton branchKey={branchKey} />
    </div>
  )
}
